<div *ngIf="isLoading; else loaded" class="center-align">
	<mat-spinner [diameter]="40"></mat-spinner>
</div>
<ng-template #loaded>
	<pershing-message *ngIf="serviceError; else advisorInfo" displayType="inpage" messageType="error"
		message="{{ 'ADVISOR.ERROR' | translate }}">
	</pershing-message>
	<ng-template #advisorInfo>
		<pershing-message *ngIf="!hasData" displayType="inpage" messageType="info"
			message="{{ 'ADVISOR.NO_DATA' | translate }}">
		</pershing-message>
		<ng-container *ngIf="hasData">
			<div *ngFor="let row of ipInfoData; index as i">
				<div class="fw-Advisor_MainContent">
					<img *ngIf="row.profileImageEncoded; else defaultLayout"
						src="data:image/png;base64,{{row.profileImageEncoded}}" alt="Profile Image"
						class="fw-Advisor_ProfilePic" />
					<ng-template #defaultLayout>
						<div class="fw-Advisor_Initials">
							<span>{{ row.ipName | advisorProfile }}</span>
						</div>
					</ng-template>
					<div>
						<div><strong>{{row.ipName | titlecaseFormat}}</strong></div>
						<ng-container *ngIf="row.addressLine.length > 0">
							<div *ngFor="let i of row.addressLine">
								{{i | titlecaseFormat}}
							</div>
						</ng-container>
						<div>{{row.city | titlecaseFormat}} {{row.state}} {{row.zip}}</div>
						<div *ngIf="row.phone"><span class="fal fa-phone-alt fw-Advisor_PhoneIcon"></span><span>{{row.phone}}</span></div>
						<div *ngIf="row.fax">
							<span class="fal fa-fax fw-Advisor_FaxIcon"></span><span>{{row.fax}}</span>
						</div>
						<div class="fw-Advisor_Link" *ngIf="row.emailAddress">
							<a class="text-link" #tooltip="matTooltip" (click)="tooltip.toggle()"
								matTooltip="{{row.emailAddress}}"
								matTooltipPosition="below" href="mailto:{{row.emailAddress}}">{{row.emailAddress}}</a>
						</div>
						<div class="fw-Advisor_Link" #tooltip="matTooltip" (click)="tooltip.toggle()"
							matTooltip="{{row.webAddress}}" matTooltipPosition="below"
							*ngIf="row.webAddress">{{row.webAddress}}</div>
					</div>
					<ng-container *ngIf="entitledForShowingProfilePic && row.descriptionLinks.length > 0">
						<div class="fw-Advisor_SubTitle">{{'ADVISOR.PROFILE_LINKS' | translate}}</div>
						<div>
							<ng-container *ngFor="let descriptionLink of row.descriptionLinks">
								<div class="fw-Advisor_Link" *ngIf="descriptionLink.hasEmail">
									<a class="text-link" #tooltip="matTooltip"
										(click)="tooltip.toggle()"
										matTooltip="{{descriptionLink.descriptionText}}"
										matTooltipPosition="below"
										href="mailto:{{descriptionLink.descriptionText}}">{{descriptionLink.descriptionText}}</a>
								</div>
								<div class="fw-Advisor_Link" *ngIf="!descriptionLink.hasEmail">
									<a class="text-link" #tooltip="matTooltip"
										(click)="tooltip.toggle()"
										matTooltip="{{descriptionLink.descriptionText}}"
										matTooltipPosition="below"
										href="{{descriptionLink.descriptionText}}">{{descriptionLink.descriptionText}}</a>
								</div>
							</ng-container>
						</div>
					</ng-container>
					<ng-container *ngIf="ipInfoData.length >= 1">
						<div class="fw-Advisor_SubTitle">{{'ADVISOR.ACCOUNTS' | translate}}</div>
						<div class="fw-Advisor_Accounts">
							<div *ngFor="let acctlist of row.ipTitleAcctList">
								{{acctlist.acctNum | accountDisplayPipe}}
							</div>
						</div>
					</ng-container>
				</div>
				<hr *ngIf="i < ipInfoData.length - 1">
			</div>
		</ng-container>
	</ng-template>
</ng-template>
